export const LABEL_SERVICE_BATCH_STATUS_IDS = {
  OPEN: -1,
  QUEUED: 0,
  PROCESSING: 1,
  GENERATING: 2,
  COMPLETED: 3,
  ARCHIVED: 4,
  NOTIFYING_MARKETPLACE: 5,
  SENDING_EMAILS: 6,
  INVALID: 7,
};
